// Documenti legali di ImmaginaCasa (#815): percorsi, versioni e date in un
// posto solo. Le pagine mostrano versione e data da qui, le spunte salvano le
// versioni da qui.
//
// Ogni modifica a un testo legale passa dal registro delle versioni
// (legalRegistry.json, procedura in docs/DOCUMENTI_LEGALI.md): il test
// tests/unit/consent/legal-registry.spec.js fallisce se un testo cambia senza
// essere registrato con `npm run legal:registra`.
//
// Quando un documento cambia nella sostanza alza la sua versione e la data:
// - PRIVACY_VERSION: è anche la `version` del consenso dei moduli
//   (privacyConsent.js) e va tenuta uguale a quella di newarc-platform
//   (lib/utils/legal_documents.dart);
// - TERMINI_VERSION: chi si registra da quel momento accetta la nuova versione
//   (legalAcceptance.js);
// - CONDIZIONI_AGENZIE_VERSION / DPA_VERSION: la piattaforma agenzie chiede di
//   nuovo l'accettazione a tutte le agenzie al primo accesso.

export const SITE_ORIGIN = "https://immaginacasa.com";

export const LEGAL_PATHS = Object.freeze({
  privacy: "/privacy-policy",
  cookie: "/cookie-policy",
  termini: "/termini-e-condizioni",
  condizioniAgenzie: "/condizioni-agenzie",
  dpa: "/accordo-trattamento-dati",
  noteLegali: "/note-legali",
  segnala: "/segnala",
});

export const PRIVACY_VERSION = 2;
export const TERMINI_VERSION = 1;
export const CONDIZIONI_AGENZIE_VERSION = 1;
export const DPA_VERSION = 1;

// Versione di ogni documento che ne ha una (cookie e note legali hanno solo la
// data).
export const LEGAL_VERSIONS = Object.freeze({
  privacy: PRIVACY_VERSION,
  termini: TERMINI_VERSION,
  condizioniAgenzie: CONDIZIONI_AGENZIE_VERSION,
  dpa: DPA_VERSION,
});

export const LEGAL_UPDATED_AT = Object.freeze({
  privacy: "7 ottobre 2026",
  cookie: "7 ottobre 2026",
  termini: "7 ottobre 2026",
  condizioniAgenzie: "7 ottobre 2026",
  dpa: "7 ottobre 2026",
  noteLegali: "7 ottobre 2026",
});

// URL assoluto di un documento: è quello che finisce nei consensi salvati,
// che sopravvivono al dominio da cui sono stati raccolti.
export function legalUrl(key) {
  return SITE_ORIGIN + LEGAL_PATHS[key];
}

// Articoli delle Condizioni agenzie da approvare specificamente (artt. 1341-1342
// c.c.): stesso elenco della spunta in piattaforma (newarc-platform,
// lib/utils/legal_documents.dart). Se cambi numerazione o titoli, cambiali in
// entrambi i posti e alza CONDIZIONI_AGENZIE_VERSION.
export const SPECIFIC_APPROVAL_ARTICLES =
  "5 (Contenuti dell'agenzia e garanzie), 9 (Corrispettivi, pagamenti e rinnovo automatico), " +
  "10 (Durata, recesso e risoluzione), 11 (Sospensione dell'account), " +
  "13 (Limitazione di responsabilità e manleva), 17 (Modifiche alle condizioni) e " +
  "19 (Legge applicabile e foro competente)";

// Indirizzo per privacy, segnalazioni e punto di contatto DSA.
export const LEGAL_CONTACT_EMAIL = "privacy@immaginacasa.com";
